module.exports = __webpack_public_path__ + "img/customize_application.3994608a.svg";